import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[ngModel][arabic]',
  host: {
    '(ngModelChange)': 'onInputChange($event)'
  }
})
export class ArabicMaskDirective {

  constructor(public model: NgControl) {}

  onInputChange(_value) {
  		var arabicCharUnicodeRange = /[\u0600-\u06FF]/;
        if ( arabicCharUnicodeRange.test(_value) )
          {
            this.model.valueAccessor.writeValue(_value);
          }
        else
          this.model.valueAccessor.writeValue('');
  }

}
